import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte,
    AangifteBerekening,
    AangifteRapport, BokkzAlgDataService,
    BokkzIbDataService, Box1Berekening,
    IncomeTaxEntity, OpbouwInkomenBox1, OpbouwLijfrente, SpecificatieLijfrente
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject, combineLatest, Subject, Subscription, takeUntil } from 'rxjs';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
    selector:
        'snelstart-venture-fiscaal-feature-box1-uitgaven-voor-inkomensvoorzieningen',
    templateUrl: './box1-uitgaven-voor-inkomensvoorzieningen.component.html',
    imports: [
        SharedUiFormControlsModule,
        CommonModule,
        SharedUiDetailsModule
    ],
    styleUrls: ['./box1-uitgaven-voor-inkomensvoorzieningen.component.scss']
})
export class Box1UitgavenVoorInkomensvoorzieningenComponent implements OnInit, OnDestroy {
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private combineLatestSubscription: Subscription | undefined;
    private destroy$ = new Subject<void>();

    private isSaving = false;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;

    @Input() aangifteRapport = {} as AangifteRapport;
    @Input() partnerRapport = {} as AangifteRapport;
    @Input() berekening = {} as AangifteBerekening;
    @Input() partnerBerekening = {} as AangifteBerekening;

    public year = 0;

    specLijfrenteFormGroup = this.fb.group<AangifteRapport>({});
    specLijfrente = {} as AangifteRapport;
    berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});
    negatievePremieFormGroup = {} as FormGroup;

    public dialogSpecAftrekPremieLijfrenteVisible = false;

    showDialogSpecAftrekPremieLijfrente() {
        this.dialogSpecAftrekPremieLijfrenteVisible = true;
    }

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.specLijfrenteFormGroup = this.fb.group<AangifteRapport>(({
            specificatieLijfrente: this.fb.group<SpecificatieLijfrente>(({
                opbouw: this.fb.group<OpbouwLijfrente>(({
                    aftrekbareLijfrentePremie: null as unknown as number,
                    jaarruimte: null as unknown as number,
                    reserveringsruimte: null as unknown as number,
                    premieGrondslag: null as unknown as number,
                    reserveringsruimteMinEen: null as unknown as number,
                    reserveringsruimteMinTwee: null as unknown as number,
                    reserveringsruimteMinDrie: null as unknown as number,
                    reserveringsruimteMinVier: null as unknown as number,
                    reserveringsruimteMinVijf: null as unknown as number,
                    reserveringsruimteMinZes: null as unknown as number,
                    reserveringsruimteMinZeven: null as unknown as number,
                    reserveringsruimteMinAcht: null as unknown as number,
                    reserveringsruimteMinNegen: null as unknown as number,
                    reserveringsruimteMinTien: null as unknown as number,
                    betaaldePremiesVoorLijfrente: null as unknown as number,
                    benutteJaarrruimte: null as unknown as number | 0,
                    resterendeJaarruimte: null as unknown as number,
                    benutteReserveringsruimte: null as unknown as number,
                    benutteReserveringsruimteMinEen: null as unknown as number,
                    benutteReserveringsruimteMinTwee: null as unknown as number,
                    benutteReserveringsruimteMinDrie: null as unknown as number,
                    benutteReserveringsruimteMinVier: null as unknown as number,
                    benutteReserveringsruimteMinVijf: null as unknown as number,
                    benutteReserveringsruimteMinZes: null as unknown as number,
                    benutteReserveringsruimteMinZeven: null as unknown as number,
                    benutteReserveringsruimteMinAcht: null as unknown as number,
                    benutteReserveringsruimteMinNegen: null as unknown as number,
                    benutteReserveringsruimteMinTien: null as unknown as number,
                    resterendeReserveringsruimteMinEen: null as unknown as number,
                    resterendeReserveringsruimteMinTwee: null as unknown as number,
                    resterendeReserveringsruimteMinDrie: null as unknown as number,
                    resterendeReserveringsruimteMinVier: null as unknown as number,
                    resterendeReserveringsruimteMinVijf: null as unknown as number,
                    resterendeReserveringsruimteMinZes: null as unknown as number,
                    resterendeReserveringsruimteMinZeven: null as unknown as number,
                    resterendeReserveringsruimteMinAcht: null as unknown as number,
                    resterendeReserveringsruimteMinNegen: null as unknown as number,
                    resterendeReserveringsruimteMinTien: null as unknown as number,
                    saldoResterendeRuimtes: null as unknown as number,
                    resterendeTotaleRuimte: null as unknown as number,
                    lijfrenteVoorKind: null as unknown as number,
                    premieAovVerzekering: null as unknown as number,
                    premieAnwVerzekering: null as unknown as number,
                    premieOmzettingForBijStaking: null as unknown as number,
                    premieAfstortingFor: null as unknown as number,
                    premieOmzettingStakingsWinstInLijfrente: null as unknown as number,
                    saldoPremiesInkomensvoorzieningen: null as unknown as number,
                    saldoNegatievePremiesInkomensvoorzieningen: null as unknown as number,
                    alGebruikteRuimteMinEen: null as unknown as number,
                    alGebruikteRuimteMinTwee: null as unknown as number,
                    alGebruikteRuimteMinDrie: null as unknown as number,
                    alGebruikteRuimteMinVier: null as unknown as number,
                    alGebruikteRuimteMinVijf: null as unknown as number,
                    alGebruikteRuimteMinZes: null as unknown as number,
                    alGebruikteRuimteMinZeven: null as unknown as number,
                    alGebruikteRuimteMinAcht: null as unknown as number,
                    alGebruikteRuimteMinNegen: null as unknown as number,
                    alGebruikteRuimteMinTien: null as unknown as number,
                    emptyField: null as unknown as number
                } as OpbouwLijfrente))
            } as SpecificatieLijfrente))
        } as AangifteRapport));
        this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                opbouwInkomen: this.fb.group<OpbouwInkomenBox1>(({
                    uitgavenVoorInkomensvoorzieningen: null as unknown as number
                } as OpbouwInkomenBox1))
            } as Box1Berekening))
        } as AangifteBerekening));
        this.negatievePremieFormGroup = this.fb.group({
            terugontvangenPremieAOV: null as unknown as number,
            terugontvangenPremieLijfrente: null as unknown as number
        });
    }

    public ngOnInit(): void {
        combineLatest([
            this.dataService.incomeTaxEntity,
            this.dataService.aangifteBerekening,
            this.dataService.partnerAangifteBerekening,
            this.dataService.aangifteRapport,
            this.dataService.partnerAangifteRapport,
            this.partner
        ])
            .pipe(takeUntil(this.destroy$))
            .subscribe(([
                            incomeTaxEntity,
                            berekening,
                            partnerBerekening,
                            aangifteRapport,
                            partnerRapport,
                            isPartner
                        ]) => {
                if (incomeTaxEntity?.aangifte) {
                    this.year = incomeTaxEntity.aangifte.aangifteJaar;
                    this.aangifte = incomeTaxEntity.aangifte as Aangifte;
                }

                this.berekening        = berekening;
                this.partnerBerekening = partnerBerekening;
                this.aangifteRapport   = aangifteRapport;
                this.partnerRapport    = partnerRapport;
                this.partnerBoolean    = isPartner;

                this.specLijfrenteFormGroup.reset();
                this.berekeningBox1FormGroup.reset();

                if (isPartner) {
                    this.specLijfrente = this.partnerRapport;
                    this.berekeningBox1FormGroup.patchValue(this.partnerBerekening);
                } else {
                    this.specLijfrente = this.aangifteRapport;
                    this.berekeningBox1FormGroup.patchValue(this.berekening);
                }

                this.updateForm();
            });

        this.disableFormGroup(this.specLijfrenteFormGroup);
        this.disableFormGroup(this.berekeningBox1FormGroup);
        this.disableFormGroup(this.negatievePremieFormGroup);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private updateForm() {
        if (this.partnerBoolean) {
            this.specLijfrente = this.partnerRapport;
            this.specLijfrenteFormGroup.patchValue(this.partnerRapport);
            this.berekeningBox1FormGroup.patchValue(this.partnerBerekening);

            const terugontvangenPremieAOV = this.aangifte?.partnerAangifte?.box1?.negatieveUitgavenVoorInkomensvoorzieningen?.['terugontvangenPremieAOV'] || 0;
            const terugontvangenPremieLijfrente = this.aangifte?.partnerAangifte?.box1?.negatieveUitgavenVoorInkomensvoorzieningen?.['terugontvangenPremieLijfrente'] || 0;
            this.negatievePremieFormGroup.patchValue({
                terugontvangenPremieAOV: terugontvangenPremieAOV || 0,
                terugontvangenPremieLijfrente: terugontvangenPremieLijfrente || 0
            });
            this.updateSaldoPremiesInkomensvoorzieningen();
            this.updateSaldoNegatievePremiesInkomensvoorzieningen();
            this.updateSaldoResterendeRuimtes();

        } else {
            this.specLijfrente = this.aangifteRapport;
            this.specLijfrenteFormGroup.patchValue(this.aangifteRapport);

            const terugontvangenPremieAOV = this.aangifte?.box1?.negatieveUitgavenVoorInkomensvoorzieningen?.['terugontvangenPremieAOV'] || 0;
            const terugontvangenPremieLijfrente = this.aangifte?.box1?.negatieveUitgavenVoorInkomensvoorzieningen?.['terugontvangenPremieLijfrente'] || 0;
            this.negatievePremieFormGroup.patchValue({
                terugontvangenPremieAOV: terugontvangenPremieAOV || 0,
                terugontvangenPremieLijfrente: terugontvangenPremieLijfrente || 0
            });
            this.updateSaldoPremiesInkomensvoorzieningen();
            this.updateSaldoNegatievePremiesInkomensvoorzieningen();
            this.updateSaldoResterendeRuimtes();
        }
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }


    hasWelPremieGeenJaarruimte() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.betaaldePremiesVoorLijfrente !== undefined && opbouw.jaarruimte === undefined
        );
    }

    hasGeenPremieWelJaarruimte() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.betaaldePremiesVoorLijfrente === undefined && opbouw.jaarruimte !== undefined
        );
    }

    hasReserveringsruimte() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimte !== 0 && (
                opbouw.benutteReserveringsruimteMinEen !== 0 ||
                opbouw.benutteReserveringsruimteMinTwee !== 0 ||
                opbouw.benutteReserveringsruimteMinDrie !== 0 ||
                opbouw.benutteReserveringsruimteMinVier !== 0 ||
                opbouw.benutteReserveringsruimteMinVijf !== 0 ||
                opbouw.benutteReserveringsruimteMinZes !== 0 ||
                opbouw.benutteReserveringsruimteMinZeven !== 0 ||
                opbouw.benutteReserveringsruimteMinAcht !== 0 ||
                opbouw.benutteReserveringsruimteMinNegen !== 0 ||
                opbouw.benutteReserveringsruimteMinTien !== 0)
        );
    }

    hasReserveringsruimteMinEen() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimteMinEen !== undefined
        );
    }

    hasReserveringsruimteMinTwee() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimteMinTwee !== undefined
        );
    }

    hasReserveringsruimteMinDrie() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimteMinDrie !== undefined
        );
    }

    hasReserveringsruimteMinVier() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimteMinVier !== undefined
        );
    }

    hasReserveringsruimteMinVijf() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimteMinVijf !== undefined
        );
    }

    hasReserveringsruimteMinZes() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimteMinZes !== undefined
        );
    }

    hasReserveringsruimteMinZeven() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimteMinZeven !== undefined
        );
    }

    hasReserveringsruimteMinAcht() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimteMinAcht !== undefined
        );
    }

    hasReserveringsruimteMinNegen() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimteMinNegen !== undefined
        );
    }

    hasReserveringsruimteMinTien() {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw;
        if (!opbouw) return false;
        return (
            opbouw.reserveringsruimteMinTien !== undefined
        );
    }

    private updateSaldoPremiesInkomensvoorzieningen() {
        const lijfrente = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.aftrekbareLijfrentePremie')?.value || 0;
        const aov = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.premieAovVerzekering')?.value || 0;
        const anw = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.premieAnwVerzekering')?.value || 0;
        const kind = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.lijfrenteVoorKind')?.value || 0;

        const saldo = lijfrente + aov + anw + kind;
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.saldoPremiesInkomensvoorzieningen')?.setValue(saldo);
    }

    private updateSaldoNegatievePremiesInkomensvoorzieningen() {
        const terugAov = this.negatievePremieFormGroup.get('terugontvangenPremieAOV')?.value || 0;
        const terugLijfrente = this.negatievePremieFormGroup.get('terugontvangenPremieLijfrente')?.value || 0;

        const saldo = terugAov + terugLijfrente;
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.saldoNegatievePremiesInkomensvoorzieningen')?.setValue(saldo);
    }

    private updateSaldoResterendeRuimtes() {

        const jaarruimte = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.jaarruimte')?.value || 0;
        const benutteJaarruimte = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteJaarrruimte')?.value > 0 ? this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteJaarrruimte')?.value : 0;
        const resterendeJaarruimte = jaarruimte - benutteJaarruimte;

        const alGebruikteRuimteMinEen = this.getAfgetrokkenPremieVoorJaar(1);
        const alGebruikteRuimteMinTwee = this.getAfgetrokkenPremieVoorJaar(2);
        const alGebruikteRuimteMinDrie = this.getAfgetrokkenPremieVoorJaar(3);
        const alGebruikteRuimteMinVier = this.getAfgetrokkenPremieVoorJaar(4);
        const alGebruikteRuimteMinVijf = this.getAfgetrokkenPremieVoorJaar(5);
        const alGebruikteRuimteMinZes = this.getAfgetrokkenPremieVoorJaar(6);
        const alGebruikteRuimteMinZeven = this.getAfgetrokkenPremieVoorJaar(7);
        const alGebruikteRuimteMinAcht = this.getAfgetrokkenPremieVoorJaar(8);
        const alGebruikteRuimteMinNegen = this.getAfgetrokkenPremieVoorJaar(9);
        const alGebruikteRuimteMinTien = this.getAfgetrokkenPremieVoorJaar(10);

        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinEen')?.setValue(alGebruikteRuimteMinEen);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinTwee')?.setValue(alGebruikteRuimteMinTwee);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinDrie')?.setValue(alGebruikteRuimteMinDrie);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinVier')?.setValue(alGebruikteRuimteMinVier);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinVijf')?.setValue(alGebruikteRuimteMinVijf);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinZes')?.setValue(alGebruikteRuimteMinZes);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinZeven')?.setValue(alGebruikteRuimteMinZeven);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinAcht')?.setValue(alGebruikteRuimteMinAcht);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinNegen')?.setValue(alGebruikteRuimteMinNegen);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinTien')?.setValue(alGebruikteRuimteMinTien);

        const reserveringsruimteMinEen = (this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinEen')?.value + this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinEen')?.value) || 0;
        const reserveringsruimteMinTwee = (this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinTwee')?.value + this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinTwee')?.value) || 0;
        const reserveringsruimteMinDrie = (this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinDrie')?.value + this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinDrie')?.value) || 0;
        const reserveringsruimteMinVier = (this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinVier')?.value + this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinVier')?.value) || 0;
        const reserveringsruimteMinVijf = (this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinVijf')?.value + this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinVijf')?.value) || 0;
        const reserveringsruimteMinZes = (this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinZes')?.value + this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinZes')?.value) || 0;
        const reserveringsruimteMinZeven = (this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinZeven')?.value + this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinZeven')?.value) || 0;
        const reserveringsruimteMinAcht = (this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinAcht')?.value + this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinAcht')?.value) || 0;
        const reserveringsruimteMinNegen = (this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinNegen')?.value + this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinNegen')?.value) || 0;
        const reserveringsruimteMinTien = (this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinTien')?.value + this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.alGebruikteRuimteMinTien')?.value) || 0;

        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinEen')?.setValue(reserveringsruimteMinEen);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinTwee')?.setValue(reserveringsruimteMinTwee);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinDrie')?.setValue(reserveringsruimteMinDrie);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinVier')?.setValue(reserveringsruimteMinVier);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinVijf')?.setValue(reserveringsruimteMinVijf);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinZes')?.setValue(reserveringsruimteMinZes);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinZeven')?.setValue(reserveringsruimteMinZeven);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinAcht')?.setValue(reserveringsruimteMinAcht);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinNegen')?.setValue(reserveringsruimteMinNegen);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.reserveringsruimteMinTien')?.setValue(reserveringsruimteMinTien);

        const benutteReserveringsruimteMinEen = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteReserveringsruimteMinEen')?.value || 0;
        const benutteReserveringsruimteMinTwee = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteReserveringsruimteMinTwee')?.value || 0;
        const benutteReserveringsruimteMinDrie = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteReserveringsruimteMinDrie')?.value || 0;
        const benutteReserveringsruimteMinVier = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteReserveringsruimteMinVier')?.value || 0;
        const benutteReserveringsruimteMinVijf = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteReserveringsruimteMinVijf')?.value || 0;
        const benutteReserveringsruimteMinZes = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteReserveringsruimteMinZes')?.value || 0;
        const benutteReserveringsruimteMinZeven = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteReserveringsruimteMinZeven')?.value || 0;
        const benutteReserveringsruimteMinAcht = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteReserveringsruimteMinAcht')?.value || 0;
        const benutteReserveringsruimteMinNegen = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteReserveringsruimteMinNegen')?.value || 0;
        const benutteReserveringsruimteMinTien = this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteReserveringsruimteMinTien')?.value || 0;

        const resterendeReserveringsruimteMinEen = reserveringsruimteMinEen - benutteReserveringsruimteMinEen - alGebruikteRuimteMinEen;
        const resterendeReserveringsruimteMinTwee = reserveringsruimteMinTwee - benutteReserveringsruimteMinTwee - alGebruikteRuimteMinTwee;
        const resterendeReserveringsruimteMinDrie = reserveringsruimteMinDrie - benutteReserveringsruimteMinDrie - alGebruikteRuimteMinDrie;
        const resterendeReserveringsruimteMinVier = reserveringsruimteMinVier - benutteReserveringsruimteMinVier - alGebruikteRuimteMinVier;
        const resterendeReserveringsruimteMinVijf = reserveringsruimteMinVijf - benutteReserveringsruimteMinVijf - alGebruikteRuimteMinVijf;
        const resterendeReserveringsruimteMinZes = reserveringsruimteMinZes - benutteReserveringsruimteMinZes - alGebruikteRuimteMinZes;
        const resterendeReserveringsruimteMinZeven = reserveringsruimteMinZeven - benutteReserveringsruimteMinZeven - alGebruikteRuimteMinZeven;
        const resterendeReserveringsruimteMinAcht = reserveringsruimteMinAcht - benutteReserveringsruimteMinAcht - alGebruikteRuimteMinAcht;
        const resterendeReserveringsruimteMinNegen = reserveringsruimteMinNegen - benutteReserveringsruimteMinNegen - alGebruikteRuimteMinNegen;
        const resterendeReserveringsruimteMinTien = reserveringsruimteMinTien - benutteReserveringsruimteMinTien - alGebruikteRuimteMinTien;

        const saldoResterendeRuimtes = resterendeReserveringsruimteMinEen + resterendeReserveringsruimteMinTwee + resterendeReserveringsruimteMinDrie + resterendeReserveringsruimteMinVier + resterendeReserveringsruimteMinVijf + resterendeReserveringsruimteMinZes + resterendeReserveringsruimteMinZeven + resterendeReserveringsruimteMinAcht + resterendeReserveringsruimteMinNegen + resterendeReserveringsruimteMinTien;

        const resterendeTotaleRuimte = saldoResterendeRuimtes + resterendeJaarruimte;

        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeReserveringsruimteMinEen')?.setValue(resterendeReserveringsruimteMinEen);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeReserveringsruimteMinTwee')?.setValue(resterendeReserveringsruimteMinTwee);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeReserveringsruimteMinDrie')?.setValue(resterendeReserveringsruimteMinDrie);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeReserveringsruimteMinVier')?.setValue(resterendeReserveringsruimteMinVier);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeReserveringsruimteMinVijf')?.setValue(resterendeReserveringsruimteMinVijf);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeReserveringsruimteMinZes')?.setValue(resterendeReserveringsruimteMinZes);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeReserveringsruimteMinZeven')?.setValue(resterendeReserveringsruimteMinZeven);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeReserveringsruimteMinAcht')?.setValue(resterendeReserveringsruimteMinAcht);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeReserveringsruimteMinNegen')?.setValue(resterendeReserveringsruimteMinNegen);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeReserveringsruimteMinTien')?.setValue(resterendeReserveringsruimteMinTien);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.benutteJaarrruimte')?.setValue(benutteJaarruimte);

        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.saldoResterendeRuimtes')?.setValue(saldoResterendeRuimtes);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeJaarruimte')?.setValue(resterendeJaarruimte);
        this.specLijfrenteFormGroup.get('specificatieLijfrente.opbouw.resterendeTotaleRuimte')?.setValue(resterendeTotaleRuimte);

    }

    private getAfgetrokkenPremieVoorJaar(jarenTerug: number): number {
        const bron = this.partnerBoolean
            ? this.aangifte.partnerAangifte?.box1
            : this.aangifte.box1;
        return bron?.uitgavenVoorInkomensvoorzieningen
            ?.jaarruimteGegevensPerJaar?.find(
                item => item.jaar === this.year - jarenTerug
            )?.afgetrokkenPremie ?? 0;
    }

    readonly ruimteJaren = [
        { offset: 10, suffix: 'MinTien' },
        { offset:  9, suffix: 'MinNegen' },
        { offset:  8, suffix: 'MinAcht' },
        { offset:  7, suffix: 'MinZeven' },
        { offset:  6, suffix: 'MinZes' },
        { offset:  5, suffix: 'MinVijf' },
        { offset:  4, suffix: 'MinVier' },
        { offset:  3, suffix: 'MinDrie' },
        { offset:  2, suffix: 'MinTwee' },
        { offset:  1, suffix: 'MinEen' },
    ];

    hasReserveringsruimteVoorJaar(jarenTerug: number): boolean {
        const opbouw = this.specLijfrente.specificatieLijfrente?.opbouw as Record<string, unknown>;
        if (!opbouw) return false;
        const suffix = this.ruimteJaren.find(j => j.offset === jarenTerug)?.suffix ?? '';
        return opbouw[`reserveringsruimte${suffix}`] !== undefined;
    }


}
